import { render, staticRenderFns } from "./IconReopenTask.vue?vue&type=template&id=39bbd858&"
import script from "./IconReopenTask.vue?vue&type=script&lang=ts&"
export * from "./IconReopenTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports